import { Progress } from "@/components/ui/progress"

// Neutral progress bar + label (design/docs/DECISIONS.md §Color — one calm
// fill everywhere; length carries the info, color carries nothing). The left
// caption names the stage; the right value is the percentage.
//
// Set `unavailable` for orders with no measurable progress (e.g. cover/format
// work) — mirrors the real dashboard's "Word count not available".
export default function ProgressCell({ value = 0, label, unavailable = false }) {
  if (unavailable) {
    return (
      <div className="min-w-[150px]">
        <span className="text-[11.5px] italic text-ink-3">
          Word count not available
        </span>
      </div>
    )
  }

  return (
    <div className="min-w-[150px]">
      <div className="mb-1.5 flex items-center justify-between text-[11px] font-semibold text-muted-foreground">
        <span>{label}</span>
        <b className="text-foreground">{value}%</b>
      </div>
      <Progress value={value} className="h-1.5" />
    </div>
  )
}
